import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";
import success from "../images/icons/Correct.svg";
import failed from "../images/icons/Failed.svg";

export const ContactForm = () => {
  const form = useRef();
  const [shows, setshows] = useState(false);
  const [showf, setshowf] = useState(false);

  const [uname, setuname] = useState("");
  const [uemail, setuemail] = useState("");
  const [umessage, setumessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qtx2156",
        "template_akczpsr",
        form.current,
        "5qBQXp8TNG2WHYkHz"
      )
      .then(
        (result) => {
          setshows(true);
          console.log(result);
          setuname("");
          setuemail("");
          setumessage("");
          setTimeout(() => {
            setshows(false);
          }, 4000);
        }
      )
      .catch((error) => {
        console.log(error);
        setshowf(true);
        setTimeout(() => {
          // window.location.reload(false);
          setshowf(false);
        }, 4000);
      });
  };

  return (
    <>
        <form ref={form} onSubmit={sendEmail}>
          <div className="mb-3">
            <label className="form-label" htmlFor="name">
              Name
            </label>
            <input
              className="form-control"
              type="text"
              id="name"
              name="user_name"
              value={uname}
              onChange={(e) => setuname(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              className="form-control"
              type="email"
              id="email"
              name="user_email"
              value={uemail}
              onChange={(e) => setuemail(e.target.value)}
              required
            />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="message">
              Message
            </label>
            <textarea
              className="form-control"
              id="message"
              name="message"
              value={umessage}
              onChange={(e) => setumessage(e.target.value)}
              required
            />
          </div>
          <div className="">
            <motion.input
              type="submit"
              value="Send"
              className="btn text-white send-btn"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
            />
          </div>
        </form>
      <Modal show={shows}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
        <Modal.Body className="text-dark">
          <div className="text-center p-3">
          <img src={success} alt="success" className="modal-img" />
          </div>
          <p className="text-center modal-p">Hooray, your email was successfully sent.</p>
        </Modal.Body>
      </Modal>
      <Modal show={showf}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
        <Modal.Body className="text-dark">
          <div className="text-center p-3">
          <img src={failed} alt="success" className="modal-img" />
          </div>
          <p className="text-center modal-p">Whoops, your email was unsuccessful.</p>
        </Modal.Body>
      </Modal>
      
    </>
  );
};
